// extracted by mini-css-extract-plugin
module.exports = {"AddReflection":"ReflectionCrud_AddReflection__2aG2C","ApproveBtn":"ReflectionCrud_ApproveBtn__S5y13"};